import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33896b33"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for", "innerHTML"]
const _hoisted_2 = { class: "InputRange__Field" }
const _hoisted_3 = ["id", "name", "min", "max", "step"]
const _hoisted_4 = ["for"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "InputRange__Progress" }, null, -1))

import { computed } from 'vue'

interface Props {
  modelValue: number
  label: string
  id?: string
  name?: string
  min?: string
  max?: string
  step?: string
  direction?: DIRECTION
  reversed?: boolean
}


import { defineComponent } from 'vue'

export const enum DIRECTION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}

const __default__ = defineComponent({})

function setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, label: string, id?: string, name?: string, min: string, max: string, step: string, direction: DIRECTION, reversed: boolean }

_useCssVars(_ctx => ({
  "8d1805aa": (__props.modelValue)
}))





const inputId = computed(() => props.id || props.name)

const value = computed({
  get: () => props.modelValue,
  set (v: number | string) {
    emit('update:modelValue', parseFloat(v as string))
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["InputRange", [`InputRange--${__props.direction}`, { 'is-reversed': __props.reversed }]])
  }, [
    _createElementVNode("label", {
      for: _unref(inputId),
      class: "small-caps",
      innerHTML: __props.label
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "range",
        id: _unref(inputId),
        name: __props.name,
        min: __props.min,
        max: __props.max,
        step: __props.step,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
      }, null, 8, _hoisted_3), [
        [_vModelText, _unref(value)]
      ]),
      _createElementVNode("output", {
        for: _unref(inputId),
        class: "small-caps"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_4),
      _hoisted_5
    ])
  ], 2))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: null,
    label: null,
    id: null,
    name: null,
    min: { default: '0' },
    max: { default: '1' },
    step: { default: '0.01' },
    direction: { default: DIRECTION.HORIZONTAL },
    reversed: { default: false }
  },
  emits: ["update:modelValue"],
  setup})